// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__34D0M","dragIcon":"SortableItem_dragIcon__R4WZB","disabled":"SortableItem_disabled__2dMkm"};